import React from 'react'
import { User } from '../../../models'

interface SimplePageLayoutProps {
    user?: User
    children: React.ReactNode
}

/**
 * Minimal layout that renders only the page content (no sidebar/top bar).
 * Used for standalone pages like application access denied.
 */
export const SimplePageLayout: React.FC<SimplePageLayoutProps> = ({
    children,
}) => {
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
                padding: 24,
                boxSizing: 'border-box',
            }}
        >
            {children}
        </div>
    )
}
